module.exports = __webpack_public_path__ + "static/bentonsans-medium-webfont-5470a0f949d631bbf587347399032b6b.woff2";